<template>
    <div>
        <div class="banner1">
            <img src="../assets/img/banner4.jpg" alt="banner" />
        </div>

        <div class="block">
            <div class="center">
                <div class="left_bar">
                    <div class="title">关于凯纳</div>
                    <ul>
                        <li><a href="javascript:void(0);" @click.stop="goTo('GongSiJianJie')">公司简介</a></li>
                        <li><a href="javascript:void(0);" @click.stop="goTo('QiYeWenHua')">企业文化</a></li>
                        <li><a href="javascript:void(0);" @click.stop="goTo('SheHuiZeRen')">社会责任</a></li>
                        <li><a href="javascript:void(0);" @click.stop="goTo('ZiZhiRongYu')">企业荣誉</a></li>
                        <li><a href="javascript:void(0);" @click.stop="goTo('GongSiZiZhi')">公司资质</a></li>
                        <li><a href="javascript:void(0);" @click.stop="goTo('DangJianGongHui')">党建工会</a></li>
                        <li><a href="javascript:void(0);" @click.stop="goTo('YuanGongFengCai')">员工风采</a></li>
                        <li><a href="javascript:void(0);" @click.stop="goTo('QiYeHuaCe')">企业画册</a></li>
                        <li><a href="javascript:void(0);" @click.stop="goTo('QiYeXuanChuanPian')">企业宣传片</a></li>
                    </ul>
                </div>
                <div class="right_contnet">
                    <h2>{{ title }}</h2>
                    <div id="contnet">
                        <div class="zoom" v-show="zoom_state" @click="zoom(false)" title="点击关闭"><img :src="zoom_url" /></div>
                        <ul class="zizhi">
                            <li v-for="(zizhi, index) in zizhi_list" :key="index" :class="[zizhi.type == 'horizontal'?'li_h':'li_v' ]">
                                <div :title="zizhi.name" @click="zoom(zizhi.url)">
                                    <img :src="zizhi.url" />
                                    <span>{{ zizhi.name }}</span>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import { ZiZhiRongYu } from "../request/api"; // 导入接口


export default {
    name: 'Home',
    data() {
        return {
            title: '公司资质',
            sub_title: '',
            windowWidth: document.documentElement.clientWidth, //实时屏幕宽度
            windowHeight: document.documentElement.clientHeight, //实时屏幕高度

            webTitle:'',
            webDescription:'',

            zoom_state : false,
            zoom_url:'',

            zizhi_list:[
                {
                    url: require('@/assets/pic/01.jpg'),
                    name: '高新技术企业证书',
                    type: 'horizontal', //横向
                },
                {
                    url: require('@/assets/pic/02.jpg'),
                    name: '软件企业证书',
                    type: 'horizontal', //横向
                },
                {
                    url: require('@/assets/pic/03.jpg'),
                    name: '软件能力成熟度证书CMMI3级',
                    type: 'horizontal', //横向
                },
                {
                    url: require('@/assets/pic/04.jpg'),
                    name: '安防工程企业维护能力证书',
                    type: 'vertical', //竖向
                },
                {
                    url: require('@/assets/pic/06.jpg'),
                    name: '信息技术服务ITSS二级',
                    type: 'horizontal', //横向
                },
                {
                    url: require('@/assets/pic/05.jpg'),
                    name: '辐射安全许可证',
                    type: 'vertical', //竖向
                },
                {
                    url: require('@/assets/pic/07.jpg'),
                    name: '信息安全等级保护安全建设服务机构能力评估合格证书',
                    type: 'vertical', //竖向
                },
                {
                    url: require('@/assets/pic/08.jpg'),
                    name: '建筑业企业资质证书（市政、机电、电子与智能化、装饰装修、环保、消防、防雷）',
                    type: 'vertical', //竖向
                },
                {
                    url: require('@/assets/pic/09.jpg'),
                    name: '通信工程总承包二级',
                    type: 'vertical', //竖向
                },
                {
                    url: require('@/assets/pic/10.jpg'),
                    name: '增值业务许可证',
                    type: 'vertical', //竖向
                },
                {
                    url: require('@/assets/pic/11.jpg'),
                    name: '信用等级证书（AAA级）',
                    type: 'vertical', //竖向
                },
                {
                    url: require('@/assets/pic/12.jpg'),
                    name: '企业信用等级认证证书（AAA级）',
                    type: 'vertical', //竖向
                },
                {
                    url: require('@/assets/pic/13.jpg'),
                    name: '两化融合管理体系评定证书（A级）',
                    type: 'vertical', //竖向
                },
                {
                    url: require('@/assets/pic/14.jpg'),
                    name: '知识产权管理体系认证证书',
                    type: 'vertical', //竖向
                },
                {
                    url: require('@/assets/pic/15.jpg'),
                    name: '职业安全健康管理体系认证ISO45001证书',
                    type: 'vertical', //竖向
                },
                {
                    url: require('@/assets/pic/16.jpg'),
                    name: '环境体系认证14001',
                    type: 'vertical', //竖向
                }
            ]
        };
    },
    created() {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
        this.ZiZhiRongYu_data();
    },
    mounted() {
        window.onresize = () => {
            //页面改变尺寸时
            return (() => {
                this.windowWidth = document.documentElement.clientWidth;
                this.windowHeight = document.documentElement.clientHeight;
            })();
        };
    },
    methods: {
        zoom( e ){
            window.scrollTo({
                top: 300,
                behavior: "smooth"
            });
            //alert( e );
            if( e != false ){
                this.zoom_url = e ;
                this.zoom_state = true;
            }else{
                this.zoom_state = e;
            };
        },
        goTo(e) {
            this.$router.push(e);
        },
        ZiZhiRongYu_data(){ //资质荣誉
            ZiZhiRongYu({
            }).then((res) => {
                this.webTitle = res.rows[0].webTitle;
                this.webDescription = res.rows[0].webDescription;
            });
        },
    },
};
</script>
<style lang="less" scoped>
#contnet{
    position: relative;
    display:block;
    margin-top: 10px;
    min-height: 500px;
    text-align: center;
    background-size: 100% auto;
    background-repeat: no-repeat;
    background-image: url('./../assets/img/qiyezizhi_bg.png');

    .zoom{
        position: absolute;
        left: 0px;
        top: 30px;
        width: 70%;
        height: auto;
        max-height: 800px;
        margin: 0px 15%;
        background-color: #fff;
        border: 5px solid #999;
        padding: 5px;
        overflow: hidden;
        overflow-y: auto;
        //box-shadow: 10px 10px 0px rgba(0,0,0,0.2), -10px -10px 0px rgba(0,0,0,0.2);
        img{
            cursor: pointer;
            max-width: 100%;
            width: 800px;
            height: auto;
            vertical-align: top;
        }
    }
    .zizhi{
        margin: 360px 20px 0px 30px;
        padding: 5px;

        li{
            user-select: none;
            display: inline-block;
            // width: 210px;
            // height: 147px;
            border-top: 8px solid #f9f8f4;
            border-right: 8px solid #efece3;
            border-bottom: 8px solid #eae8e0;
            border-left: 8px solid #f9f8f4;
            background-color: #ebeae6;
            box-shadow: inset 2px 2px 0px #ccc, inset -2px -2px 0px #e4dbdb;
            padding: 10px;
            

            div{
                background-color: #fff;
                width: 100%;
                height: 100%;
                span{
                    cursor: default;
                    display: block;
                    text-align: center;
                    width: 100%;
                    margin-top: 20px;
                    min-height: 30px;
                    font-size: 14px;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }
                img{
                    vertical-align: top;
                    height: 100%;
                    max-width: 100%;
                }
            }
        }
        .li_h{
            width: 210px;
            height: 147px;
            margin: 5px 20px;
        }
        .li_v{
            // width: 98px;
            // height: 147px;
            // margin: 5px 76px;
            width: 140px;
            height: 210px;
            margin: 5px 55px;
        }
        li:hover{
            animation: li_hover 0.3s linear forwards;
            @keyframes li_hover {
                0% {
                    border-top: 8px solid #f9f8f4;
                    border-right: 8px solid #efece3;
                    border-bottom: 8px solid #eae8e0;
                    border-left: 8px solid #f9f8f4;
                    background-color: #ebeae6;
                    box-shadow: 5px 5px 0px rgba(255,255,255,0);
                }
                100% {
                    border-top: 8px solid #ecd6b7;
                    border-right: 8px solid #ffffdc;
                    border-bottom: 8px solid #ffffdc;
                    border-left: 8px solid #ecd6b7;
                    background-color: #f2efe5;
                    box-shadow: 5px 5px 0px rgba(0,0,0,0.2);
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/GongSiZiZhi.vue